import { z } from 'zod';

export const donorFormSchema = z.object({
  email: z
    .string()
    .min(1, 'Email is required')
    .email('Invalid email address')
    .toLowerCase()
    .trim(),
  firstName: z.string().max(100).trim().optional(),
  lastName: z.string().max(100).trim().optional(),
  phone: z
    .string()
    .max(20, 'Phone number must not exceed 20 characters')
    .trim()
    .optional(),
  amount: z.number().positive('Amount must be positive').int('Amount must be a whole number').optional(),
  recurringSchedule: z.enum(['one_time', 'monthly', 'yearly'], {
    errorMap: () => ({ message: 'Please select a valid donation schedule' }),
  }).optional(),
});

export type DonorFormData = z.infer<typeof donorFormSchema>;

// Validation for amount input
export const amountSchema = z
  .number()
  .positive('Amount must be greater than 0')
  .finite('Amount must be a valid number');

// Validation for email only (for quick donation)
export const emailSchema = z
  .string()
  .min(1, 'Email is required')
  .email('Invalid email address')
  .toLowerCase()
  .trim();
